import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, rem, utilityStyles } from './../../styles';
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "mws4fn",
  styles: "opacity:0"
} : {
  name: "14pj6f8-defaultStyles",
  styles: "opacity:0;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles(_ref4) {
  var src = _ref4.src,
    isAnimated = _ref4.isAnimated;
  return /*#__PURE__*/css("transition:opacity 1s;", src !== '' && isAnimated && _ref3, " canvas{display:block;height:auto;visibility:hidden;width:100%;}svg,img{height:100%;left:0;position:absolute;top:0;width:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "179v0z5-baseDensityStyles",
  styles: "overflow:hidden;label:baseDensityStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var densityStyles = function densityStyles(_ref5) {
  var density = _ref5.density,
    size = _ref5.size;
  if (density == 'compact') {
    var baseDensityStyles = _ref2;
    switch (size) {
      case 'xs':
        return /*#__PURE__*/css(baseDensityStyles, " width:", rem(68), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
      case 'sm':
        return /*#__PURE__*/css(baseDensityStyles, " width:", rem(102), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
      case 'lg':
        return /*#__PURE__*/css(baseDensityStyles, " width:", rem(180), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
      case 'md':
        return /*#__PURE__*/css(baseDensityStyles, " width:", rem(130), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
    }
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "3ix1vd",
  styles: "opacity:1"
} : {
  name: "1odh8ln-isLoadedStyles",
  styles: "opacity:1;label:isLoadedStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isLoadedStyles = function isLoadedStyles(_ref6) {
  var isLoaded = _ref6.isLoaded;
  if (isLoaded) return _ref;
};
var resetStyles = getResetByTag('div');
var StyledVehicleImage = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "enopuxz0"
} : {
  target: "enopuxz0",
  label: "StyledVehicleImage"
})(resetStyles, defaultStyles, densityStyles, isLoadedStyles, utilityStyles);
export default StyledVehicleImage;